module.exports = __webpack_public_path__ + "static/media/clipper.018638bd.png";